import { ReactMarkdown } from 'react-markdown/lib/react-markdown'

import * as S from './styles'
import { Tag, Text } from '@/components'
import { Article } from '@/service/api/blog'

export type ContentContainerProps = {
  /**
   * Data of the article
   *
   * @example
   * ```tsx
   * <ContentContainer data={articleData} />
   * ```
   */
  data: Article
  /**
   * Tags of the article
   *
   * @example
   * ```tsx
   * <ContentContainer tags={['Tag 1', 'Tag 2']} />
   * ```
   *
   * @default []
   */
  tags?: string[]
}
export const ContentContainer: React.FC<ContentContainerProps> = ({ data }) => (
  <S.ContentContainer>
    <Text size="h1" className="title" color="darkgray">
      {data.title}
    </Text>
    <S.TagContainer>
      {data.tags.map((tag) => (
        <Tag key={tag} label={tag} />
      ))}
    </S.TagContainer>

    <ReactMarkdown className="content">{data.content}</ReactMarkdown>
  </S.ContentContainer>
)
